import { FilmAdvanceBookingPeriodRestriction } from '@vista-digital/ocapi-types/v1';
import { sortArrayByProperty } from '../../../../utils/array-utils';
import { logger } from '../../../../utils/logger';
import { getMemberRewardById } from '../../../loyalty/selectors/member/rewards/get-member-reward-by-id';
/**
 * Returns the earliest available advance booking period for the current patron.
 */
export const getEarliestAvailableAdvanceBookingPeriod = (bookingPeriods, bookingMode) => {
    const availablePeriods = bookingPeriods.filter(bookingPeriod => {
        if (bookingMode && !bookingPeriod.orderBookingModes.includes(bookingMode))
            return false;
        return isAdvanceBookingPeriodAvailable(bookingPeriod);
    });
    return sortArrayByProperty(availablePeriods, 'startsAt')[0];
};
/**
 * Determines whether a booking period is available to the current patron.
 */
const isAdvanceBookingPeriodAvailable = (bookingPeriod) => {
    switch (bookingPeriod.restriction) {
        case FilmAdvanceBookingPeriodRestriction.None:
            return true;
        case FilmAdvanceBookingPeriodRestriction.MemberReward:
            return isMemberRewardBookingPeriodAvailable(bookingPeriod);
        default:
            logger.warn(`Cannot access advance booking period with unknown restriction '${bookingPeriod.restriction}'.`);
            return false;
    }
};
/**
 * Determines whether a member reward booking period is available.
 * The member only needs to have access to the reward — the balance cost and available quantity are ignored as the reward does not need to be redeemed.
 */
const isMemberRewardBookingPeriodAvailable = (bookingPeriod) => {
    return !!getMemberRewardById(bookingPeriod.rewardId);
};
export const isMemberRewardFilmAdvanceBookingPeriod = (bookingPeriod) => {
    return bookingPeriod.restriction === FilmAdvanceBookingPeriodRestriction.MemberReward;
};
